<div class="visitor-registration-preparation">
    <sc-padding>
        <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

            <!-- <sc-content-spacer [vertical]="true"></sc-content-spacer> -->
            <table>
                <thead>
                    <tr>
                    <td class="company">{{'Company' | translate: ['tmc-visit.entity.visit.company', translationService.language]}}</td>
                    <td class="name">{{'Name' | translate: ['tmc-visit.entity.visit.name', translationService.language]}}</td>
                    <td class="firstname">{{'Firstname' | translate: ['tmc-visit.entity.visit.firstname', translationService.language]}}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entry of preparations">
                        <td class="">{{entry.company}}</td>
                        <td class="">{{entry.name}}</td>
                        <td class="">{{entry.firstname}}</td>
                        <td>
                          <sc-button dictionaryKey="tmc-visit.widgets.registration-terminal.visitor-registration-preparation.button.register" (click)="selectPreparation(entry)"></sc-button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <sc-content-spacer [vertical]="true" [grow]="true"></sc-content-spacer>

        </sc-flex>
    </sc-padding>
</div>